import { numberToPrettyString } from '@cian/utils';

import { IOffer } from '../../../types/offer';

function getPricePerMeterValue(offer: IOffer): number | undefined {
  if (offer.pricePerUnitAreaRur && offer.pricePerUnitAreaRur > 0) {
    return offer.pricePerUnitAreaRur;
  }

  const totalArea = Number(offer.totalArea);
  if (!Number.isFinite(totalArea) || totalArea <= 0) {
    return undefined;
  }

  const totalPrice = offer.bargainTerms?.priceRur || offer.minPriceTotalRur;
  if (!totalPrice || totalPrice <= 0) {
    return undefined;
  }

  return Math.round(totalPrice / totalArea);
}

export function getCommercialSalePricePerMeter(offer: IOffer): string | undefined {
  const value = getPricePerMeterValue(offer);
  if (!value) {
    return undefined;
  }

  return `${numberToPrettyString(value)} ₽/м²`;
}
